import React, { useState } from "react";
import "./HotelListFilterCard.scss";
import { Checkbox, FormControlLabel } from "@mui/material";

interface FilterOption {
  id: string;
  label: string;
}

interface HotelListFilterCardProps {
  title?: string;
  filters: FilterOption[];
  selectedFilters: string[];
  onFilterChange: (selected: string[]) => void;
}

const HotelListFilterCard: React.FC<HotelListFilterCardProps> = ({
  title,
  filters,
  selectedFilters,
  onFilterChange,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const handleCheckboxChange = (id: string) => {
    const newFilters = selectedFilters.includes(id)
      ? selectedFilters.filter((item) => item !== id)
      : [...selectedFilters, id];

    onFilterChange(newFilters);
  };

  return (
    <div className="filter-container ">
      <div
        className="filter-header"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h5>{title}</h5>
        <span className="collapse-icon">{isOpen ? "−" : "+"}</span>
      </div>

      {isOpen && (
        <div
          className={`filter-body  ${
            title === "Popular Locations" ? "scrollable-body" : ""
          }`}
        >
          {filters.map((filter) => (
            <FormControlLabel
              className="filter-label"
              key={filter.id}
              control={
                <Checkbox
                  checked={selectedFilters.includes(filter.id)}
                  onChange={() => handleCheckboxChange(filter.id)}
                  sx={{
                    color: "inherit", // uses text color instead of blue
                    "&.Mui-checked": {
                      color: "inherit", // keeps same color even when checked
                    },
                  }}
                />
              }
              label={filter.label}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default HotelListFilterCard;
